
import React from "react";

type Props = React.PropsWithChildren<{
  title: string;
  onClose: () => void;
  width?: number | string;
  actions?: React.ReactNode;
}>;

export function Modal({ title, onClose, children, width = 600, actions }: Props) {
  // 點擊 Esc 關閉
  React.useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000
    }} onClick={onClose}>
      <div 
        className="card" 
        style={{ width: width, maxHeight: "90vh", display: "flex", flexDirection: "column", padding: 0, overflow: "hidden" }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ padding: "16px 20px", borderBottom: "1px solid var(--border)", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#1a1d24" }}>
          <h3 className="h1" style={{ fontSize: 18, margin: 0 }}>{title}</h3>
          <button onClick={onClose} style={{ background: "transparent", border: "none", color: "var(--muted)", fontSize: 20, cursor: "pointer" }}>×</button>
        </div>
        
        <div style={{ padding: 20, overflowY: "auto", flex: 1 }}>
          {children}
        </div>

        {actions && (
          <div style={{ padding: "16px 20px", borderTop: "1px solid var(--border)", background: "#1a1d24", display: "flex", gap: 10, justifyContent: "flex-end" }}>
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
